<template>
	<div class="collapse-fiona bg-white-glass" v-cloak>
		<div class="relative">
			<div class="collapse-selection-container" :class="{ 'justify-center': shouldShowScrollRight }" @scroll="handleCollapseScroll" ref="collapseTabs">
				<div
						v-for="(item, index) in collapseItems"
						:key="item.title"
						class="collapse-selector"
						:ref="`collapseSelector${index}`"
						@click="currentItemIndex = index"
						:class="{ 'active': currentItemIndex === index }">
					<div>
						<div class="collapse-icon">
							<img :src="item.icon.url" :alt="item.icon.alt || ''">
						</div>
						<h5>{{ item.title }}</h5>
					</div>
				</div>
			</div>
			<div class="collapse-selection-arrow-left" @click="scrollLeft" :class="{ hidden: shouldShowScrollLeft }">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><path fill="currentColor" d="m191.907 0 .186 30.187L94.28 128l97.813 97.813-.186 30.187-128-128Z"/></svg>
			</div>
			<div class="collapse-selection-arrow-right" @click="scrollRight" :class="{ hidden: shouldShowScrollRight }">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><path fill="currentColor" d="m64.093 0-.186 30.187L161.72 128l-97.813 97.813.186 30.187 128-128z"/></svg>
			</div>
		</div>
		<div class="collapse-item-content-wrapper">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			items: String
		},
		computed: {
			shouldShowScrollLeft: function () {
				return this.collapseSelectorScroll < 5;
			},
			shouldShowScrollRight: function () {
				this.windowWidth; // make it reactive
				if (!this.$refs.collapseTabs?.scrollWidth)
					return true;
				return this.collapseSelectorScroll >= this.$refs.collapseTabs?.scrollWidth - this.$refs.collapseTabs?.clientWidth - 5;
			},
		},
		watch: {
			currentItemIndex(val) {
				this.$eventHub.$emit('updateTabItemIndex', val, this);
			}
		},
		methods: {
			handleCollapseScroll: function() {
				this.collapseSelectorScroll = this.$refs.collapseTabs?.scrollLeft;
			},
			scrollLeft: function() {
				this.$refs.collapseTabs.scrollBy({ left: -128, behavior: "smooth" });
			},
			scrollRight: function() {
				this.$refs.collapseTabs.scrollBy({ left: 128, behavior: "smooth" });
			},
		},
		mounted() {
			this.handleCollapseScroll();
			this.windowWidth = window.innerWidth;
			window.addEventListener('resize', () => {
				this.windowWidth = window.innerWidth;
			});
		},
		data() {
			return {
				collapseItems: JSON.parse(this.items) ?? {},
				currentItemIndex: 0,
				collapseSelectorScroll: 0,
				windowWidth: 0
			};
		},
	};
</script>
